import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import TopBar from "./TopBar";
// import "./Navbar.css";

function Header(props) {
  // const IMAGEURL = process.env.REACT_APP_IMAGE_URL;
  const [org, setOrg] = useState("");
  // const organizationDetails = props.orgDetail;

  useEffect(() => {
    if (props.orgDetails) {
      setOrg(props.orgDetails);
    }
  }, [props.orgDetails]);

  return (
    <div>
              <TopBar contactList={props.contacts} orgDetail={props.orgDetails} />
        <Navbar orgDetail={props.orgDetails} />
      {/*</div>*/}
    </div>
  );
}

export default Header;
